import React from "react";

export default function CustomModal({
  isOpen,
  onClose,
  title,
  message,
  primaryText,
  secondaryText,
  onPrimary,
  onSecondary,
  icon,
}) {
  if (!isOpen) return null;

  return (
    <div className="rccg-modal-overlay" onClick={onClose}>
      <div className="rccg-modal" onClick={(e) => e.stopPropagation()}>
        {icon && <div className="rccg-modal-icon">{icon}</div>}

        <h4 className="rccg-modal-title">{title}</h4>
        <p className="rccg-modal-message">{message}</p>

        <div className="rccg-modal-buttons">
          {secondaryText && (
            <button className="rccg-btn-outline" onClick={onSecondary}>
              {secondaryText}
            </button>
          )}
          {primaryText && (
            <button className="rccg-btn-primary" onClick={onPrimary}>
              {primaryText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
